/* eslint-disable max-classes-per-file */
import { VKAtgardKoppladAtgardDTO } from "../../models/atgard-models";

export class AtgardStatusesDTO {
    atgardGUID: string;
    atgardstyp: string;
    affarsform: string;
    naturvardesbedomning: VKAtgardStatusNaturvardesbedomningDTO;
    naturvardesbedomningDatumLegacy: string;
    larmPunkterCount: number;
    avlaggCount: number;
    avlaggAllTillganglighetsklass: boolean;
    kojplatserCount: number;
    foreslagetProduktionsdatumFrom: string;
    foreslagetProduktionsdatumTom: string;
    koppladeAtgarder: VKAtgardKoppladAtgardDTO[];
    extraKartinfo: VKAtgardStatusExtraKartinfoDTO;
    avverkningsanmalan: VKAtgardStatusAvverkningsanmalanDTO;
}

export class VKAtgardStatusNaturvardesbedomningDTO {
    nvbKravsEj?: boolean;
    utfordAv: string;
    utfordDatum: string;
}

export class VKAtgardStatusExtraKartinfoDTO {
    renskotselOmraden: string;
    rennaringAretRunt: boolean;
    fjallnara: boolean;
    iflOmrade: boolean;
}

export class VKAtgardStatusAvverkningsanmalanDTO {
    giltigtTillDatum: string;
    godkantDatum: string;
    avverkningsanmalanTyp: string;
    utfordDatum: string;
    farStartaDatum: string;
}
